import { ReviewData } from '../@types/review';

export const sampleReviews1: ReviewData[] = [
    // เว็บที่ 1 - 6 รีวิว
    {
        id: '1',
        phoneNumber: '0812345678',
        rating: 5,
        reviewText: 'บริการดีมาก ฝาก-ถอนรวดเร็ว แนะนำเลยครับ แค่ 30 วินาทีเงินเข้าแล้ว',
        reviewDate: '2025-07-15T10:30:00Z'
    },
    {
        id: '2',
        phoneNumber: '0823456789',
        rating: 5,
        reviewText: 'เกมแจกดีมากๆ เลยครับ โบนัสแตกบ่อย ทำเงินได้ทุกวัน',
        reviewDate: '2025-07-14T14:20:00Z'
    },
    {
        id: '3',
        phoneNumber: '0834567890',
        rating: 5,
        reviewText: 'เว็บเสถียรมาก เล่นได้ลื่นไม่มีสะดุด ทำเงินได้ทุกวัน',
        reviewDate: '2025-07-13T09:15:00Z'
    },
    {
        id: '4',
        phoneNumber: '0845678901',
        rating: 5,
        reviewText: 'เล่นมา 6 เดือน กำไรดี ไม่เคยมีปัญหาเรื่องเงิน จ่ายจริง',
        reviewDate: '2025-07-12T16:45:00Z'
    },
    {
        id: '5',
        phoneNumber: '0856789012',
        rating: 4,
        reviewText: 'สล็อตแตกง่าย เล่นสนุก กำไรดี ฝากขั้นต่ำแค่ 1 บาท',
        reviewDate: '2025-07-11T11:30:00Z'
    },
    {
        id: '6',
        phoneNumber: '0867890123',
        rating: 5,
        reviewText: 'โปรโมชั่นเยอะมาก คืนยอดเดิมพัน 0.3% สะสมได้ ดีมากๆ',
        reviewDate: '2025-07-10T08:20:00Z'
    },
];

export const sampleReviews2: ReviewData[] = [
    // เว็บที่ 2 - 6 รีวิว
    {
        id: '7',
        phoneNumber: '0878901234',
        rating: 4,
        reviewText: 'บาคาร่าเล่นได้ลื่น ภาพชัด เดิมพันขั้นต่ำ 10 บาท เหมาะกับทุกคน',
        reviewDate: '2025-07-09T19:10:00Z'
    },
    {
        id: '8',
        phoneNumber: '0889012345',
        rating: 5,
        reviewText: 'ฝากเงินผ่าน True Wallet ง่ายมาก ไม่มีขั้นต่ำ ถอนได้จริง',
        reviewDate: '2025-07-08T13:25:00Z'
    },
    {
        id: '9',
        phoneNumber: '0890123456',
        rating: 4,
        reviewText: 'เกมมีให้เลือกเยอะ สล็อต บาคาร่า ยิงปลา บอล ครบครันดี',
        reviewDate: '2025-07-07T15:40:00Z'
    },
    {
        id: '10',
        phoneNumber: '0901234567',
        rating: 5,
        reviewText: 'โบนัสทำเทิร์นน้อยมาก x3 เท่านั้น ถอนได้เลย ไม่มีโกง',
        reviewDate: '2025-07-06T12:15:00Z'
    },
    {
        id: '11',
        phoneNumber: '0912345670',
        rating: 5,
        reviewText: 'แอดมินดูแลดีมาก ตอบไว ปัญหาหายในพริบตา บริการ 24 ชั่วโมง',
        reviewDate: '2025-07-05T09:30:00Z'
    },
    {
        id: '12',
        phoneNumber: '0923456701',
        rating: 4,
        reviewText: 'ระบบอัตโนมัติดี ฝาก-ถอนไม่ต้องรอแอดมิน รวดเร็วมาก',
        reviewDate: '2025-07-04T17:20:00Z'
    },

];

export const sampleReviews3: ReviewData[] = [
    // เว็บที่ 3 - 6 รีวิว
    {
        id: '13',
        phoneNumber: '0934567012',
        rating: 5,
        reviewText: 'แจ็คพอตแตกบ่อย เล่นสล็อต PG ได้กำไรดีมาก แนะนำครับ',
        reviewDate: '2025-06-28T11:45:00Z'
    },
    {
        id: '14',
        phoneNumber: '0945678123',
        rating: 5,
        reviewText: 'เว็บใหม่ แต่น่าเชื่อถือ มีใบอนุญาต ปลอดภัย 100%',
        reviewDate: '2025-06-27T14:30:00Z'
    },
    {
        id: '15',
        phoneNumber: '0956789234',
        rating: 4,
        reviewText: 'บาคาร่าได้เงินจริง ไม่มีการโกง เล่นยังไงก็จ่าย',
        reviewDate: '2025-06-26T16:10:00Z'
    },
    {
        id: '16',
        phoneNumber: '0967890345',
        rating: 5,
        reviewText: 'บาคาร่าออนไลน์ดีมาก เล่นง่าย ได้เงินจริง มั่นคง',
        reviewDate: '2025-06-25T08:50:00Z'
    },
    {
        id: '17',
        phoneNumber: '0978901456',
        rating: 5,
        reviewText: 'เล่นสล็อตแตกง่าย กำไรดีมากๆ RTP สูง จ่ายจริง',
        reviewDate: '2025-06-24T13:15:00Z'
    },
    {
        id: '18',
        phoneNumber: '0989012567',
        rating: 4,
        reviewText: 'มีเกมยิงปลา สนุกมาก กำไรดี เล่นง่าย',
        reviewDate: '2025-06-23T19:40:00Z'
    },

];

export const sampleReviews4: ReviewData[] = [
    // เว็บที่ 4 - 6 รีวิว
    {
        id: '19',
        phoneNumber: '0990123678',
        rating: 5,
        reviewText: 'อัตราการจ่ายสูง RTP 98% เล่นแล้วคุ้ม ได้เงินจริง',
        reviewDate: '2025-06-18T10:25:00Z'
    },
    {
        id: '20',
        phoneNumber: '0801234789',
        rating: 5,
        reviewText: 'เว็บใช้งานง่าย เล่นผ่านมือถือได้ลื่น ไม่ต้องดาวน์โหลด',
        reviewDate: '2025-06-17T15:35:00Z'
    },
    {
        id: '21',
        phoneNumber: '0812345890',
        rating: 4,
        reviewText: 'เกมส์หลากหลาย ค่ายดัง PG SLOT, PRAGMATIC, JOKER, Jili ครบ',
        reviewDate: '2025-06-16T12:20:00Z'
    },
    {
        id: '22',
        phoneNumber: '0823456901',
        rating: 5,
        reviewText: 'แอดมินตอบเร็วมาก 24 ชั่วโมง แก้ปัญหาได้ดี',
        reviewDate: '2025-06-15T18:45:00Z'
    },
    {
        id: '23',
        phoneNumber: '0834567012',
        rating: 5,
        reviewText: 'โบนัสสมาชิกใหม่ 100% คุ้มมาก เล่นได้นาน',
        reviewDate: '2025-06-14T07:30:00Z'
    },
    {
        id: '24',
        phoneNumber: '0845678123',
        rating: 4,
        reviewText: 'ระบบการเงินดีมาก ฝากผ่านแบงค์ อัตโนมัติ เร็วทันใจ',
        reviewDate: '2025-06-13T20:15:00Z'
    },

];

export const sampleReviews5: ReviewData[] = [
    // เว็บที่ 5 - 6 รีวิว
    {
        id: '25',
        phoneNumber: '0856789234',
        rating: 5,
        reviewText: 'เว็บตรงไม่ผ่านเอเย่นต์ ปลอดภัย มั่นคง ไว้ใจได้',
        reviewDate: '2025-06-30T11:50:00Z'
    },
    {
        id: '26',
        phoneNumber: '0867890345',
        rating: 5,
        reviewText: 'มีโปรสมาชิกใหม่ดีมาก ฝาก 100 ได้ 200 คุ้มสุดๆ',
        reviewDate: '2025-06-29T14:40:00Z'
    },
    {
        id: '27',
        phoneNumber: '0878901456',
        rating: 4,
        reviewText: 'ระบบฝาก-ถอนอัตโนมัติ 24 ชั่วโมง ไม่มีวันหยุด',
        reviewDate: '2025-06-28T09:25:00Z'
    },
    {
        id: '28',
        phoneNumber: '0889012567',
        rating: 5,
        reviewText: 'เล่นเกมสล็อตได้เงินจริง ไม่โกง จ่ายจริง แนะนำเลย',
        reviewDate: '2025-05-27T16:30:00Z'
    },
    {
        id: '29',
        phoneNumber: '0890123678',
        rating: 5,
        reviewText: 'มีระบบป้องกันการล็อคยูส ดีมากๆ',
        reviewDate: '2025-05-26T13:10:00Z'
    },
    {
        id: '30',
        phoneNumber: '0901234789',
        rating: 4,
        reviewText: 'ทุนน้อยเล่นได้ เริ่มต้น 1 บาท เหมาะกับนักเล่นใหม่',
        reviewDate: '2025-05-25T19:55:00Z'
    }
];

export const sampleReviews6: ReviewData[] = [
    {
        id: '31',
        phoneNumber: '0849583069',
        rating: 5,
        reviewText: 'เว็บนี้ของจริง ไม่ล็อคยูส เล่นแตกกี่รอบก็ถอนได้ครบ ไม่ได้แจกแต่สมาชิกใหม่เด้อ ประทับใจตรงนี้แหละ',
        reviewDate: '2025-08-27T18:20:00Z'
    },
    {
        id: '32',
        phoneNumber: '0978106999',
        rating: 4,
        reviewText: 'ฝาก-ถอน ถือว่าค่อนข้างไว ถ้าฝากไม่เข้ามีอัพสลีปใด้ ไม่ต้องทักหาแอดมินเลย ออโต้ที่แท้ทรู',
        reviewDate: '2025-08-26T12:45:00Z'
    },
    {
        id: '33',
        phoneNumber: '0915869223',
        rating: 5,
        reviewText: 'เว็บนี้ของแท้แน่นอน ถามแอนมินมีสอนวิธีดูของแท้ด้วย โง่ตั้งนาน',
        reviewDate: '2025-08-25T21:10:00Z'
    },
    {
        id: '34',
        phoneNumber: '0605697848',
        rating: 5,
        reviewText: 'ระบบดี ค่อนข้างเสถียร เล่นมายังไม่มีปัญหา ถอนได้ตลอดไม่ตุกติก',
        reviewDate: '2025-08-24T15:05:00Z'
    },
    {
        id: '35',
        phoneNumber: '0838576092',
        rating: 4,
        reviewText: 'แอดตอบไวดี ถามไรตอบได้ไม่ต้องรอนาน พูดเพราะไม่เหวี่ยง',
        reviewDate: '2025-08-23T10:30:00Z'
    },
    {
        id: '36',
        phoneNumber: '0888345678',
        rating: 5,
        reviewText: 'ค่ายเยอะดี สล็อตแตกง่ายจัด อย่างชอบ',
        reviewDate: '2025-08-22T10:30:00Z'
    }
];

export const sampleReviews7: ReviewData[] = [
    {
        id: '31',
        phoneNumber: '0848573867',
        rating: 5,
        reviewText: 'เว็บนี้จริงใจ ไม่ล็อกยูสเลย เล่นได้เท่าไหร่ถอนได้หมด ไม่ได้เอาใจแต่ลูกค้าใหม่ ถูกใจตรงนี้แหละ',
        reviewDate: '2025-08-27T18:20:00Z'
    },
    {
        id: '32',
        phoneNumber: '0919345755',
        rating: 4,
        reviewText: 'ฝากถอนค่อนข้างไว ถ้าระบบไม่เข้าก็อัพสลิปได้เลย ไม่ต้องคุยกับแอดมินให้ยุ่ง ออโต้สุดๆ',
        reviewDate: '2025-08-26T12:45:00Z'
    },
    {
        id: '33',
        phoneNumber: '09094867423',
        rating: 5,
        reviewText: 'เว็บนี้ชัวร์แน่นอน แอดมินยังสอนวิธีเช็คว่าเว็บจริงหรือไม่อีก รู้ทีหลังเสียดายเวลาเลย',
        reviewDate: '2025-08-25T21:10:00Z'
    },
    {
        id: '34',
        phoneNumber: '0630965869',
        rating: 5,
        reviewText: 'ระบบเสถียรดีมาก เล่นมาไม่เคยเจอปัญหา ถอนเงินได้จริงไม่มีโกง',
        reviewDate: '2025-08-24T15:05:00Z'
    },
    {
        id: '35',
        phoneNumber: '0820596777',
        rating: 4,
        reviewText: 'ทีมงานตอบเร็ว พูดเพราะ ใส่ใจลูกค้า ไม่ต้องรอนานเลย',
        reviewDate: '2025-08-23T10:30:00Z'
    },
    {
        id: '36',
        phoneNumber: '0893453245',
        rating: 5,
        reviewText: 'มีหลายค่ายให้เลือก เกมแตกง่ายจริงๆ ชอบมาก',
        reviewDate: '2025-08-22T10:30:00Z'
    }    
];

// export const getRandomReviews = (count: number = 5): ReviewData[] => {
//     const shuffled = [...sampleReviews].sort(() => 0.5 - Math.random());
//     return shuffled.slice(0, count);
// };

// export const getReviewsByRating = (rating: number): ReviewData[] => {
//     return sampleReviews.filter(review => review.rating === rating);
// };

// export const getAverageRating = (): number => {
//     const total = sampleReviews.reduce((sum, review) => sum + review.rating, 0);
//     return Math.round((total / sampleReviews.length) * 10) / 10;
// }; 